import React, { useState } from "react";
import {
    Stack,
    IconButton,
    Pagination,
    PaginationItem,
    Box,
    Button
} from "@mui/material";
import {
    FirstPage,
    LastPage,
    ArrowBackIosNew,
    ArrowForwardIos
} from "@mui/icons-material";
import ConfirmDeleteModal from "../ConfirmDeleteModal";

const KayakTablePagination = ({
    page,
    totalItems,
    rowsPerPage,
    onPageChange,
    onBulkDelete,
    onClearFilters,
    isFiltersDisable,
    disableDelete = false
}) => {
    const [openBulkDelete, setOpenBulkDelete] = useState(false);
    const pageCount = Math.ceil(totalItems / rowsPerPage);

    return (
        <>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ width: "100%", marginTop: "10px" }}
            >
                {/* Left Buttons: Delete & Clear Filters */}
                <Box display="flex" gap={1}>
                    <IconButton
                        size="small"
                        disabled={disableDelete}
                        sx={{
                            backgroundColor: "#61D5A9",
                            borderRadius: "10px",
                            fontWeight: 400,
                            fontSize: "10px",
                            fontStyle: "Roboto",
                            "&:hover": {
                                backgroundColor: "#61D5A9"
                            }
                        }}
                        onClick={() => setOpenBulkDelete(true)}
                    >
                        Delete Selected
                    </IconButton>
                    <Button
                        size="small"
                        variant="outlined"
                        disabled={isFiltersDisable}
                        sx={{
                            borderColor: "#ccc",
                            fontSize: "10px",
                            height: "28px",
                            textTransform: "none"
                        }}
                        onClick={onClearFilters}
                    >
                        Clear Filters
                    </Button>
                </Box>

                {/* Right Pagination */}
                <Pagination
                    count={pageCount}
                    page={page + 1}
                    onChange={(event, value) => onPageChange(event, value - 1)}
                    siblingCount={1}
                    boundaryCount={1}
                    showFirstButton
                    showLastButton
                    size="small"
                    renderItem={(item) => (
                        <PaginationItem
                            components={{
                                first: FirstPage,
                                last: LastPage,
                                previous: ArrowBackIosNew,
                                next: ArrowForwardIos
                            }}
                            {...item}
                            sx={{
                                fontSize: "10px",
                                height: "14px",
                                minWidth: "24px",
                                borderRadius: "0",
                                color: "#454545",
                                "& svg": { width: "10px" },
                                "&.Mui-selected": {
                                    backgroundColor: "transparent",
                                    fontWeight: 600,
                                    border: "none",
                                    boxShadow: "none"
                                },
                                "&.Mui-selected:hover": { backgroundColor: "transparent" }
                            }}
                        />
                    )}
                />
            </Stack>

            {/* Bulk Delete Modal */}
            <ConfirmDeleteModal
                open={openBulkDelete}
                onClose={() => setOpenBulkDelete(false)}
                onConfirm={() => {
                    setOpenBulkDelete(false);
                    onBulkDelete();
                }}
                title="Delete Selected Rows"
                message="Are you sure you want to delete the selected rows?"
            />
        </>
    );
};

export default KayakTablePagination;
